import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled, { css } from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${COLORS.STATIC.BLACK};
  opacity: 0.3;
  z-index: 10;

  &.drawer-fade-enter {
    opacity: 0;
  }
  &.drawer-fade-enter-active {
    opacity: 0.3;
    transition: opacity 200ms ease;
  }
  &.drawer-fade-exit {
    opacity: 0.3;
  }
  &.drawer-fade-exit-active {
    opacity: 0;
    transition: opacity 200ms ease;
  }
`;

const BaseWrap = styled.div`
    position: fixed;
    
    z-index: 11;
    overflow: clip auto;
    background: ${COLORS.BG.PAGE};

    display: flex;
    flex-direction: column;
`;
type Pos = 'top' | 'bottom' | 'left' | 'right' | 'submenu';
type AnimatedWrapProps = {
  $position: Pos;
  $borderRadius?: number[];
}

const getVariables = (pos: Pos) => {
  let str = ''
  switch (pos) {
    case 'top':
      str = 'width: 100vw;\nheight: max-content;\n';
      str += 'left: 0;top:0;\n'
      str += '--slide-enter-transform: translateY(-100%);\n'
      str += '--slide-enter-active-transform: translateY(0);\n'
      break;
    case 'bottom':
      str = 'width: 100vw;\nheight: max-content;\n';
      str += 'bottom: 0;left:0;\n'
      str += '--slide-enter-transform: translateY(100%);\n'
      str += '--slide-enter-active-transform: translateY(0);\n'
      break;
    case 'left':
      str = 'height: 100dvh;\nwidth: max-content;\n';
      str += 'left: 0;top:0;\n'
      str += '--slide-enter-transform: translateX(-100%);\n'
      str += '--slide-enter-active-transform: translateX(0);\n'
      break;
    case 'right':
      str = 'height: 100dvh;\nwidth: max-content;\n';
      str += 'right:0;top:0;\n'
      str += '--slide-enter-transform: translateX(100%);\n'
      str += '--slide-enter-active-transform: translateX(0);\n'
      break;
    case 'submenu':
      str = 'height: 100dvh;\nwidth: max-content;\n';
      str += 'left: 240px;top:0;\n'
      str += '--slide-enter-transform: translateY(-100%);\n'
      str += '--slide-enter-active-transform: translateY(0);\n'
      break;
  }
  
  return str;
}

const getBorderRadius = (brad: number[]) => {
  if (!brad.length) return '0'
  
  if (brad.length > 3) return `${toRem(brad[0])} ${toRem(brad[1])} ${toRem(brad[2])} ${toRem(brad[3])}`

  if (brad.length > 2) return `${toRem(brad[0])} ${toRem(brad[1])} ${toRem(brad[2])}`

  if (brad.length > 1) return `${toRem(brad[0])} ${toRem(brad[1])}`

  return  `${toRem(brad[0])}`
}

export const AnimatedWrap = styled(BaseWrap)<AnimatedWrapProps>`
  ${props => props.$borderRadius && css`border-radius: ${getBorderRadius(props.$borderRadius)};` }
  ${props => {
    return css`${getVariables(props.$position)}`
  }}
  &.drawer-slide-enter {
    transform: var(--slide-enter-transform);
  }
  &.drawer-slide-enter-active {
    transform: var(--slide-enter-active-transform);
    transition: transform 200ms ease-in-out;
  }
  &.drawer-slide-exit {
    transform: var(--slide-enter-active-transform);
  }
  &.drawer-slide-exit-active {
    transform: var(--slide-enter-transform);
    transition: transform 200ms ease-in-out;
  }
`;